export default function SvgProfile() {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.63395 5.42859C7.65116 5.42859 6.04492 7.09563 6.04492 9.15094C6.04492 11.2062 7.65116 12.8733 9.63395 12.8733C11.6197 12.8733 13.223 11.2062 13.223 9.15094C13.223 7.09563 11.6197 5.42859 9.63395 5.42859ZM9.63395 12.0475C8.09243 12.0475 6.8451 10.7502 6.8451 9.15094C6.8451 7.55168 8.09538 6.25749 9.63395 6.25749C11.1784 6.25749 12.4257 7.55168 12.4257 9.15094C12.4257 10.7502 11.1784 12.0475 9.63395 12.0475Z"
        fill="white"
      />
      <path
        d="M12.8804 13.5714H6.00444C4.58326 13.5714 3.32579 14.2342 2.59082 15.2379C2.89387 15.5661 3.22478 15.8691 3.58356 16.15C4.21055 15.2379 5.3252 14.6319 6.58614 14.6319H12.2987C13.6224 14.6319 14.7858 15.301 15.3884 16.2857C15.7541 16.0143 16.092 15.7176 16.409 15.3988C15.6914 14.3068 14.3748 13.5714 12.8804 13.5714Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5 19C14.7467 19 19 14.7467 19 9.5C19 4.25329 14.7467 0 9.5 0C4.25329 0 0 4.25329 0 9.5C0 14.7467 4.25329 19 9.5 19ZM9.50005 18.2083C14.3095 18.2083 18.2084 14.3094 18.2084 9.49996C18.2084 4.69048 14.3095 0.791626 9.50005 0.791626C4.69057 0.791626 0.791713 4.69048 0.791713 9.49996C0.791713 14.3094 4.69057 18.2083 9.50005 18.2083Z"
        fill="#D9D9D9"
      />
    </svg>
  );
}
